import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const MekaniskEmpiriskDim: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='81'
			height='81'
			viewBox='0 0 81 81'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Frame 1'>
				<path
					id='Vector 221'
					d='M9 72C13.8962 55.6667 33.5508 23 73 23'
					stroke='#FF9600'
					strokeWidth='2'
					strokeLinecap='round'
				/>
				<line
					id='Line 1548'
					x1='73'
					y1='12'
					x2='9'
					y2='12'
					stroke='#444F55'
					strokeWidth='2'
					strokeDasharray='5 5'
				/>
				<path id='Vector 222' d='M1 0V80H81' stroke='#444F55' strokeWidth='2' />
			</g>
		</svg>
	);
};
